export default "__VITE_ASSET__D6S$jzIL__"